import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';

type UiApiPostProps = {
  data?: Record<string, any>;
  download?: boolean;
};

export const getData =
  (config: ApiConfig) =>
  ({ data, download }: UiApiPostProps): Promise<any> => {
    let url = `${config.userapiendpoint}ui-api/get-data`;

    if (download) url = `${config.userapiendpoint}ui-api/get-data-download`;

    return fetchWrapper(
      url,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
  };

export const getRebalanceData =
  (config: ApiConfig) =>
  ({ data }: { data: Record<string, any> }): Promise<any> => {
    return fetchWrapper(
      `${config.userapiendpoint}ui-api/get-rebalance-data`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
  };

export const getDataSourceData =
  (config: ApiConfig) =>
  ({ data }: { data: Record<string, any> }): Promise<any> => {
    return fetchWrapper(
      `${config.userapiendpoint}ui-api/preview`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
  };
